import { i18n } from '@/i18n';
import { DialogListConfig, ModuleListConfig, ModuleName } from '@/types/module-type';
import TopBanner from '@/components/area/japan/top-banner.vue';
import JapanHotMerchant from '@/components/area/japan/hot-merchant.vue';
import DualColumn from '@/components/area/japan/dual-column.vue';
import BottomBanner from '@/components/area/japan/bottom-banner.vue';
import AreaREcommend from '@/components/area-recommend.vue';

/** 跨境游-日本-顶部banner */
export const JAPAN_TOP_BANNER_POSID = '1100040000370019';
/** 跨境游-日本-底部banner */
export const JAPAN_BOTTOM_BANNER_POSID = '1100040000370020';
/** 双栏模块左栏在商户列表中的位置（第三项） */
export const JAPAN_DUAL_COLUMN_LEFT_INDEX = 2;
/** 双栏模块右栏在商户列表中的位置（第四项） */
export const JAPAN_DUAL_COLUMN_RIGHT_INDEX = 3;

// 日本模块配置
export const JAPAN_MODULE_CONF: ModuleListConfig = [
  {
    moduleName: ModuleName.JapanTopBanner,
    component: TopBanner,
    sort: 1,
    extraConfig: {
      modulePositionId: [JAPAN_TOP_BANNER_POSID],
    },
  },
  {
    moduleName: ModuleName.JapanFeaturedMerchants,
    component: JapanHotMerchant,
    sort: 2,
  },
  {
    moduleName: ModuleName.JapanDualColumn,
    component: DualColumn,
    sort: 3,
  },
  {
    moduleName: ModuleName.JapanBottomBanner,
    component: BottomBanner,
    sort: 4,
    extraConfig: {
      modulePositionId: [JAPAN_BOTTOM_BANNER_POSID],
    },
  },
  {
    moduleName: ModuleName.AreaREcommend,
    component: AreaREcommend,
    sort: 5,
    moduleTitle: i18n('探尋更多目的地'),
  },
];

// 日本弹窗配置
export const JAPAN_DIALOG_CONF: DialogListConfig = [];
